export default {
  DAILY: { type: 'DAILY', title: 'frequency.daily', intl: true },
  WEEKLY: { type: 'WEEKLY', title: 'frequency.weekly', intl: true },
  BEWEEKLY: { type: 'BEWEEKLY', title: 'frequency.beweekly', intl: true },
  FORTNIGHTLY: { type: 'FORTNIGHTLY', title: 'frequency.fortnightly', intl: true },
  MONTHLY: { type: 'MONTHLY', title: 'frequency.monthly', intl: true },
  QUARTERLY: { type: 'QUARTERLY', title: 'frequency.quarterly', intl: true },
};
